import React, { useState, useEffect } from "react";
import { LoadingOutlined } from "@ant-design/icons";

/* React Router */
import { Link } from "react-router-dom";

/* assets */
import prodLogo from "../../../../assets/svg/logo-title-prod-new.svg";
import stageLogo from "../../../../assets/svg/logo-title-stage-new.svg";
import testLogo from "../../../../assets/svg/logo-title-testing-new.svg";

import { Layout, Dropdown, Avatar, Space } from "antd";
import { UserOutlined, LogoutOutlined, DownOutlined } from "@ant-design/icons";
import "./style.scss";
import { useAuthorization } from "../../../../store/AuthorizationContext";
import axios from "axios";
import config from "../../../../config";

const { Header } = Layout;

const Navbar = () => {
  const [env, setEnv] = useState(null);
  const url = window.location.hostname;
  const urlSegments = url.split(".");
  const envVariable = urlSegments[0];
  const [roles, setRoles] = useState(null);

  useEffect(() => {
    if (envVariable === "staging") {
      setEnv("STAGING");
    } else if (envVariable === "mdm") {
      setEnv("PROD");
    } else if (envVariable === "localhost" || 127) {
      setEnv("TESTING");
    } else {
      setEnv("PROD");
    }
  }, [envVariable]);

  useEffect(() => {
    const fetchRoles = async()=>{
      try{
       const permissionsResponse = await axios.post(
          `${config.backendHost}auth/permissions`,
          {
            access_token: token,
          }
        );
         setRoles(permissionsResponse.data.roles);
      }
      catch (error) {
        console.error("Error fetching roles:", error);
      }
    }
    fetchRoles();
    }, []);

  const items = [
    {
      label: (
        <div className="dropdown-role-item" style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 180 }}>
          <span className="dropdown-role-label" style={{ fontSize: 14, minWidth: 48, textAlign: 'right', display: 'inline-block' }}>Roles:</span>
          <span className="dropdown-role-value" style={{ fontSize: 14, flex: 1, minWidth: 0, wordBreak: 'break-all', textAlign: 'left' }}>
            {Array.isArray(roles) && roles.length > 0
              ? roles.join(", ")
              : <LoadingOutlined spin style={{ fontSize: 14, color: "#d9d9d9" }} />}
          </span>
        </div>
      ),
      key: "roles-display",
      disabled: true,
    },
    { type: "divider" },
    {
      label: (
        <div className="dropdown-item-flex">
          <LogoutOutlined style={{ marginRight: 8 }} />
          Logout
        </div>
      ),
      key: "item-logout",
      onClick: () => {
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
        window.location.href = "/";
      },
    },
  ];

  const token = localStorage.getItem("token");
  const decode = JSON.parse(atob(token.split(".")[1]));

  return (
    <Header className={`my-header-${env}`}>
      <div className="logo-container">
        <div>
          <Link to={"/customers"}>
            {process.env.REACT_APP_ENV === "production" ? (
              <img src={prodLogo} alt="Reach24-logo" />
            ) : process.env.REACT_APP_ENV === "staging" ? (
              <img src={stageLogo} alt="Reach24-logo" />
            ) : (
              <img src={testLogo} alt="Reach24-logo" />
            )}
          </Link>
        </div>
      </div>

      <div className="profile">
        <Avatar size="small" icon={<UserOutlined />} />
        <span className="username">{decode.email}</span>
        <Dropdown className="dropdown" arrow menu={{ items }} style={{ padding: "0px" }}>
          <a className="ant-dropdown-link" href="/customers" onClick={(e) => e.preventDefault()}>
            <Space>
              <DownOutlined />
            </Space>
          </a>
        </Dropdown>
      </div>
    </Header>
  );
};

export default Navbar;
